var map = {
	"./booleantv-desktop.png": "80f6",
	"./deliveroo-desktop.png": "45a4",
	"./digitalcean-desktop.png": "5409",
	"./helbiz-desktop.png": "b866",
	"./iaccademy-desktop.png": "329e",
	"./molisana-desktop.png": "4879",
	"./spotify-desktop.png": "5c87",
	"./todo-desktop.png": "d0c9"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "96ba";